const ROUTE_PAIRS = [
  { cs: '/ostudiu', en: '/about' },
  { cs: '/sluzby', en: '/services' },
  { cs: '/service', en: '/service' },
  { cs: '/kalendar', en: '/calendar' },
  { cs: '/editor-rezervaci', en: '/booking-editor' },
  { cs: '/kontakt', en: '/contact' },
  { cs: '/cenik', en: '/pricing' },
  { cs: '/aktuality', en: '/news' },
  { cs: '/portfolio', en: '/portfolio' },
  { cs: '/faq', en: '/faq' },
  { cs: '/vybaveni', en: '/equipment' },
  { cs: '/btc', en: '/btc' },
];

export const isExternalPath = (path = '') => /^(https?:|mailto:|tel:|#)/i.test(path);

export const normalizePath = (path = '/') => {
  if (!path || path === '/') {
    return '/';
  }

  const normalized = path.startsWith('/') ? path : `/${path}`;
  return normalized.length > 1 ? normalized.replace(/\/+$/, '') : normalized;
};

export const stripLanguagePrefix = (path = '/') => {
  const normalized = normalizePath(path);

  if (normalized === '/en') {
    return '/';
  }

  if (normalized.startsWith('/en/')) {
    return normalizePath(normalized.slice(3));
  }

  return normalized;
};

export const getLanguageFromPath = (path = '/', fallback = 'cs') => {
  const normalized = normalizePath(path);
  if (normalized === '/en' || normalized.startsWith('/en/')) {
    return 'en';
  }
  return fallback === 'en' ? 'en' : 'cs';
};

const matchRoutePair = (path) => {
  const normalized = normalizePath(path);
  const candidates = ROUTE_PAIRS.flatMap((pair) => [
    { pair, source: pair.cs },
    { pair, source: pair.en },
  ]).sort((left, right) => right.source.length - left.source.length);

  return candidates.find(({ source }) => normalized === source || normalized.startsWith(`${source}/`));
};

export const translateRoutePath = (path = '/', targetLanguage = 'cs') => {
  const normalized = stripLanguagePrefix(path);

  if (normalized === '/') {
    return '/';
  }

  const match = matchRoutePair(normalized);
  if (!match) {
    return normalized;
  }

  const targetBase = targetLanguage === 'en' ? match.pair.en : match.pair.cs;
  const remainder = normalized.slice(match.source.length);
  return normalizePath(`${targetBase}${remainder}`);
};

export const localizePath = (path = '/', targetLanguage = 'cs') => {
  if (isExternalPath(path)) {
    return path;
  }

  const translatedPath = translateRoutePath(path, targetLanguage);

  if (targetLanguage === 'en') {
    return translatedPath === '/' ? '/en' : `/en${translatedPath}`;
  }

  return translatedPath;
};
